import React, { Component } from 'react'
import { Modal, Button, Checkbox, ControlLabel } from 'react-bootstrap';
import { connect } from 'react-redux';

import Loader from "components/elements/loader/Loader";
import ContractTypeSelect from "components/ContractTypeSelect/ContractTypeSelect";

import { updateContractTypeSeller } from "reducers/seller/sellerActions";
import { showWarningMessage } from "reducers/application/applicationActions";
import classNames from 'classnames';

import history from 'routes/History/history';

class ContractTypeModal extends Component {

    constructor(props) {
        super(props);
        this.state = {
            type: "",
            typeError: null,
            nit: "",
            nitError: null,
            invoiceName: "",
            invoiceNameError: null,
            loading: false,
            termsConditionsAccepted: false
        }
    }

    validate = () => {
        if (this.state.type == null || this.state.type === "") {
            const message = "Por favor seleccione un tipo de contrato";
            this.props.showWarningMessage(message);
            this.setState({ typeError: message });
            return false;
        }
        if (this.state.type === "WITH_BILLING") {

            if (this.state.invoiceName == null || this.state.invoiceName === "") {
                const message = "Por favor ingrese Razón Social";
                this.props.showWarningMessage(message);
                this.setState({ invoiceNameError: message });
                return false;
            }
            if (this.state.nit == null || this.state.nit === "") {
                const message = "Por favor ingrese su NIT";
                this.props.showWarningMessage(message);
                this.setState({ nitError: message });
                return false;
            }

        }
        return true;
    }

    save = () => {
        if (this.validate()) {
            this.setState({ loading: true });

            console.log("state", this.state);

            let nit = this.state.type === 'WITH_BILLING' ? this.state.nit : "";
            let invoiceName = this.state.type === 'WITH_BILLING' ? this.state.invoiceName : "";

            let promise = new Promise((resolve, reject) => {
                this.props.updateContractTypeSeller(
                    {
                        type: this.state.type,
                        nit: nit,
                        invoiceName: invoiceName
                    },
                    resolve,
                    reject
                );
            });

            promise.then(() => {
                this.props.onHide();
                this.setState({
                    loading: false
                });
            }, () => {
                this.setState({
                    loading: false
                });
            });

        }
    }

    onNitChange(evt) {
        if (evt.target.value !== "") {
            this.setState({ nitError: null })
        }
        this.setState({ nit: evt.target.value });
    }

    onInvoiceNameChange(evt) {
        if (evt.target.value !== "") {
            this.setState({ invoiceNameError: null })
        }
        this.setState({ invoiceName: evt.target.value });
    }

    handleTypeChange(type) {
        if (type.value !== "" && type.value !== null) {
            this.setState({ typeError: null });
        }
        this.setState({ type: type.value });
    }

    handleCheckChange = (evt) => {
        this.setState({ termsConditionsAccepted: evt.target.checked });
    }

    goToHome = () => {
        history.push('/');
    }

    render() {
        const { typeError, nitError, invoiceNameError } = this.state;
        const typeClass = classNames('form-group',
            { 'has-error': typeError != null }
        );
        const nitClass = classNames('form-group',
            { 'has-error': nitError != null }
        );
        const invoiceNameClass = classNames('form-group',
            { 'has-error': invoiceNameError != null }
        );
        return (
            <Modal
                {...this.props}
                animation={false}
                bsSize="large"
                keyboard={false}
                aria-labelledby="contained-modal-title-sm"
                backdrop={"static"} >
                <Modal.Header>
                    <Modal.Title>Selección de Contrato</Modal.Title>
                </Modal.Header>

                <Modal.Body>
                    <form className="form">
                        <div className={typeClass}>
                            <ControlLabel><b>Tipo de contrato:</b></ControlLabel>
                            <ContractTypeSelect
                                disabled={this.state.loading}
                                selection={this.state.type}
                                handleChange={(type) => this.handleTypeChange(type)}
                            />
                            <span className="help-block">{typeError}</span>
                        </div>

                        {this.state.type === "WITH_BILLING" &&
                            <div>
                                <div className={invoiceNameClass}>
                                    <ControlLabel><b>Razón Social:</b></ControlLabel>
                                    <div className="input-group">
                                        <input type="text" className="form-control"
                                            disabled={this.state.loading}
                                            onChange={(evt) => this.onInvoiceNameChange(evt)}
                                            name="invoiceName"
                                            placeholder="Razón Social" />
                                    </div>
                                    <span className="help-block">{invoiceNameError}</span>
                                </div>
                                <div className={nitClass}>
                                    <ControlLabel><b>NIT:</b></ControlLabel>
                                    <div className="input-group">
                                        <input type="number" className="form-control"
                                            disabled={this.state.loading}
                                            onChange={(evt) => this.onNitChange(evt)}
                                            name="nit"
                                            placeholder="NIT" />
                                    </div>
                                    <span className="help-block">{nitError}</span>
                                </div>
                            </div>
                        }

                        {this.state.type != null && this.state.type !== "" &&
                            <div>
                                <div className="form-group">
                                    <textarea disabled="true" className="form-control" rows="5" >
                                    TERMINOS Y CONDICIONES GENERALES DE LA CONTRATACIÓN: Contrato de PRESTACIÓN DE SERVICIOS DE EJECUTIVO/A INDEPENDIENTE, que se suscribe en virtud de las disposiciones establecidas en el Artículo 1260 Capítulo V, del Código de Comercio y conforme al tenor de las siguientes cláusulas y condiciones que a continuación se estipulan: 
PRIMERA: DE LAS PARTES.  Forman parte integrante en la celebración del presente contrato las siguientes: 
1.1. La sociedad “OGANETWORK S.R.L.”, quien para los efectos del presente contrato se denominará “LA EMPRESA”. 
1.2. Para los efectos del presente contrato se denominará EL/LA “EJECUTIVO/A INDEPENDIENTE”.
Asimismo, los antes nombrados acuerdan que en adelante y para los efectos del presente Contrato, podrán ser denominados conjuntamente como las “partes” o individualmente como la “parte”, según el contexto en el cual se utilice cada denominación.
SEGUNDA: DE LOS ANTECEDENTES. Las partes declaran lo siguiente:
2.1. “OGANETWORK S.R.L.”, es una empresa dedicada principalmente al rubro inmobiliario y comercializadora de lotes de terrenos que forman parte de “LOS PORTONES DEL URUBÓ”. En este sentido y para fines legales, requiere el servicio de EL/LA EJECUTIVO/A INDEPENDIENTE para llevar a cabo las actividades detalladas en la Cláusula Tercera siguiente. 
2.2. Por su parte EL/LA EJECUTIVO/A INDEPENDIENTE declara ser una persona con la intención de promover y vender los productos de “OGANETWORK S.R.L.”
TERCERA: DEL OBJETO.  
3.1. En virtud de los antecedentes señalados en la Cláusula anterior, por el presente contrato “OGANETWORK S.R.L.” contrata los servicios de EL/LA EJECUTIVO/A INDEPENDIENTE para la promoción y venta de productos COMERCIALIZADOS POR “OGANETWORK S.R.L.” bajo la modalidad de pago por comisión de conformidad al Artículo 1260 y 1270, del Código de Comercio. 
CUARTA: ALCANCE DE LA PRESTACIÓN DEL SERVICIO. 
4.1. EL/LA EJECUTIVO/A INDEPENDIENTE al ser un comercializador inmobiliario independiente, desarrollará sus servicios por cuenta propia, no tendrá ningún grado de dependencia con LA EMPRESA, ni cumplirá horarios para realizar las labores de venta, no tiene la obligación de estar presente en las oficinas de LA EMPRESA y su pago será por los servicios prestados. 
4.2. EL/LA EJECUTIVO/A INDEPENDIENTE solamente OFERTARÁ Y PROMOVERÁ la comercialización de productos de “OGANETWORK S.R.L.” por lo tanto, le está absoluta, expresa y terminantemente PROHIBIDO RECIBIR DINERO a nombre de la empresa, bajo pena de incurrir en los delitos de abuso de confianza, apropiación indebida y/u otros delitos, SIENDO ESTE SUFICIENTE MOTIVO PARA LA RESCISIÓN DEL PRESENTE CONTRATO, además de acciones legales si correspondiera.
QUINTA: DEL MONTO ECONÓMICO RECONOCIDO COMO PAGO POR COMISIÓN DE VENTAS. 
5.1. El monto reconocido y aceptado por LAS PARTES, de pagos por comisiones de ventas será descrito en el Manual de Riqueza Total, cuya versión final y actualizada estará disponible en la Oficina Virtual. Es obligación de EL/LA “EJECUTIVO/A INDEPENDIENTE” estar actualizado con la última versión disponible en la Oficina Virtual.
5.2. Eventualmente se realizan promociones para incentivos de venta y/o bonos adicionales, mismos que estarán expuestos en la Oficina Virtual, insertos en el Manual de Riqueza Total, documento que es periódicamente actualizado por LA EMPRESA.
SEXTA: PLAZO.  
6.1. EL/LA EJECUTIVO/A INDEPENDIENTE desarrollará la prestación de sus servicios, en un plazo establecido de UN (1) AÑO, que serán computados a partir de la firma del presente contrato de conformidad al Art. 1263 y 1264 del Código de Comercio. 
6.2. Pasado el periodo de UN (1) AÑO, el contrato se auto renueva de manera anual. 
SÉPTIMA: OBLIGACIONES DEL EJECUTIVO INDEPENDIENTE CON LA EMPRESA. 
EL/LA “EJECUTIVO/A INDEPENDIENTE” deberá cumplir con lo siguiente:
•	Representar a LA EMPRESA respetando la calidad, imagen corporativa y trato al cliente.
•	Mantener absoluta y estricta confidencialidad sobre todos y cada uno de los términos, obligaciones, alcances y derechos contenidos en el presente contrato.
•	Abstenerse de ceder, transferir y/o subrogar total o parcialmente derechos u obligaciones derivadas del presente contrato sin la debida autorización de LA EMPRESA.
•	El/La Ejecutivo/a Independiente, una vez inscrito, es responsable del pago total y puntual de las cuotas mensuales y la firma del CONTRATO DE COMPRAVENTA.
•	Cumplir con cada una de las cláusulas del presente contrato de Ejecutivo Independiente, Código de Ética y del Manual de Riqueza Total. 
OCTAVA: DEL PAGO DE LAS COMISIONES. 
8.1. EL/LA EJECUTIVO/A INDEPENDIENTE tiene derecho a una comisión por la prestación de sus servicios, convenida de conformidad al Artículo 1271 del Código de Comercio, asimismo, cuando EL/LA EJECUTIVO/A INDEPENDIENTE no presente una factura por los servicios prestados, autoriza a LA EMPRESA a realizar la retención tributaria del 12.5% del IUE y 3% del IT, equivalentes al 15.5% correspondiente a los impuestos de ley, porcentualmente en base a la suma previamente establecida. 
8.2. Se deja claramente establecido que el manejo del usuario y contraseña de la oficina virtual es personal y confidencial asumiendo de esta manera todas las responsabilidades emergentes por el mal uso por parte de EL/LA EJECUTIVO/A INDEPENDIENTE. 
8.3. Además, se deja claramente establecido que, LA EMPRESA realizará el débito automático de sus comisiones por cada cuota mensual vencida del CONTRATO DE COMPRA VENTA.
NOVENA: OBLIGACIONES DE LA EMPRESA. LA EMPRESA deberá cumplir con lo siguiente:
•	Proceder al pago de sus comisiones a EL/LA “EJECUTIVO/A INDEPENDIENTE” oportunamente, según lo convenido.
•	Dar información del estado de cuentas DEL/LA “EJECUTIVO/A INDEPENDIENTE” cada vez que lo solicite.
DÉCIMA: DE LA CONFIDENCIALIDAD. La descripción de la confidencialidad para El Manual de Riqueza Total, Código de Ética y Contrato de Ejecutivo independiente esta descrita en la Sección 6 del (Código de Ética).
DÉCIMA PRIMERA: DEL TIEMPO DE LA CONFIDENCIALIDAD. La obligación a la que se refiere la cláusula anterior, surtirá efectos a partir de la fecha de firma del presente contrato y tendrá vigencia aun después de concluida la relación principal entre las partes, por un período de TRES (3) AÑOS,  contados a partir de la fecha de terminación de dicha relación, con el fin de proteger la confidencialidad de todos los intereses anteriormente descritos, reconociendo y aceptando EL/LA EJECUTIVO/A INDEPENDIENTE que de no cumplir con ésta obligación, causará daños y perjuicios a LA EMPRESA y responderá por tales daños.
DÉCIMA SEGUNDA: RESOLUCIÓN DE CONTRATO. El presente contrato podrá ser resuelto de la siguiente manera de conformidad con el Artículo 1266 del Código de Comercio y Articulo 569 del Código Civil, privando a la otra parte de los derechos que emergen del mismo:
•	En común acuerdo entre partes.
•	De forma unilateral, cuando una de las partes incumpliera con cualquiera de las cláusulas y/o contenido de este contrato, del Código de Ética y del Manual de Riqueza Total, sin necesidad de intervención o requerimiento judicial alguno y/o a simple presentación de nota por escrito de LA EMPRESA, por lo que, a partir de ese momento, EL/LA “EJECUTIVO/A INDEPENDIENTE” quedará desautorizado y/o prohibido de promocionar, comercializar y vender lotes de terreno de LA EMPRESA.
DÉCIMA TERCERA: SERVICIOS INDEPENDIENTES.
13.1. Se deja claramente  establecido que el presente contrato de conformidad con el Art. 1269 del Código de Comercio y Articulo 732 del Código Civil,  por prestación de servicios queda fuera de los alcances de la Ley General del Trabajo toda vez que no existe ni podrá existir ninguna relación ni obligación laboral alguna entre LA EMPRESA y EL/LA EJECUTIVO/A INDEPENDIENTE, por no existir relación de dependencia, pago o una remuneración mensual producto de una actividad laboral, daño o reclamo que pueda surgir como consecuencia de este contrato. 
13.2. EL/LA EJECUTIVO/A INDEPENDIENTE deberá cumplir con toda acreditación legal requerida por la AEMP, Impuestos Nacionales o cualquier institución y/o autoridad competente para el normal desempeño de sus servicios. 
DÉCIMA CUARTA: LEGISLACIÓN APLICABLE Y SOLUCIÓN DE CONTROVERSIAS POR PROCESOS DE ARBITRAJE Y CONCILIACIÓN. En caso de surgir controversias entre las partes que no puedan ser solucionadas por la vía de la concertación, las partes declaran, acuerdan y deciden someter sus controversias al ámbito del arbitraje y conciliación, a cuyo efecto se contemplará durante el curso de la ejecución del servicio o después de su terminación o en la etapa de liquidación del contrato, como un medio alternativo de solución rápida, efectiva, excluyente y definitiva, antes de someter sus litigios a los Tribunales Ordinarios o durante el trámite Judicial, aplicando la normativa prevista de acuerdo a la Legislación Boliviana Ley 708 del 25 de junio del 2015 de conciliación y arbitraje, modificada por Ley N°936 del 03 de mayo de 2017,  se llevara a cabo en el Centro de Conciliación y Arbitraje  de la CAINCO.
DÉCIMA QUINTA: CALIDAD DE DOCUMENTO PRIVADO. Este documento tiene el valor de un documento privado a todos los efectos legales aplicables, por lo tanto, este documento privado tiene efectos jurídicos entre las Partes, de conformidad con las disposiciones del Artículo 138 del Código Procesal Civil, pudiendo ser reconocido por la vía voluntaria o por la vía judicial.
DÉCIMA SEXTA: ANEXOS. Los anexos (Código de Ética y Manual de Riqueza Total) adjuntos al presente contrato, son considerados parte indivisible del mismo, surtiendo los mismos efectos contractuales, obligatorios del presente documento, motivo por el cual las partes se obligan a su cumplimiento.
DÉCIMA SÉPTIMA: DE LAS CLÁUSULAS Y EL CONTRATO. Las cláusulas del presente Contrato se entenderán de interpretación conjunta, entendiéndose el mismo como un todo. En caso de que se declare la nulidad o invalidez de alguna cláusula, las demás mantendrán su validez.
DÉCIMA OCTAVA: DE LA ACEPTACIÓN. Las partes contratantes manifiestan su conformidad con todas y cada una de las cláusulas establecidas en el presente documento. 
Obligaciones del Usuario: El usuario deberá respetar en todo momento los términos y condiciones establecidos en el presente aviso legal. De forma expresa el usuario manifiesta que utilizará el portal de forma diligente y asumiendo cualquier responsabilidad que pudiera derivarse del incumplimiento de las normas.
El usuario se obliga, en aquellos casos que se le soliciten datos o información, a no falsear su identidad haciéndose pasar por cualquier otra persona. El usuario acepta que la utilización del Portal será efectuada con fines estrictamente personales, privados y particulares. El usuario no podrá utilizar el portal para actividades contrarias a la Ley, la moral y el orden público, así como para finalidades prohibidas o que vulneren o lesionen derechos de terceros. Asimismo, queda prohibida la difusión, almacenamiento y/o gestión de datos o contenidos que infrinjan derechos de terceros o cualesquiera normativas reguladoras de derechos de propiedad.
                                </textarea>
                                </div>
                                <Checkbox inline checked={this.state.termsConditionsAccepted}
                                    onChange={this.handleCheckChange}>
                                    &nbsp;Acepto términos y Condiciones
                                </Checkbox>
                            </div>
                        }


                    </form>
                </Modal.Body>

                <Modal.Footer>
                    {this.state.loading == false ?
                        <div>
                            <Button onClick={() => this.goToHome()} >Cancelar</Button> &nbsp;
                            <Button disabled={this.state.termsConditionsAccepted == false} onClick={this.save} className="bg-light-secondary">Guardar</Button>
                        </div>
                        :
                        <div className="w-100">
                            <Loader classes="password-modal__spinner" show={true} />
                        </div>
                    }
                </Modal.Footer>
            </Modal>
        )
    }
}
const mapStateToProps = state => ({
});
export default connect(
    mapStateToProps,
    { showWarningMessage, updateContractTypeSeller }
)(ContractTypeModal);



// WEBPACK FOOTER //
// ./src/components/ContractTypeModal/ContractTypeModal.jsx